/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileFormatHtmlIcon16Solid = forwardRef('FileFormatHtmlIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.182 1a2 2 0 0 1 1.415.586l2.817 2.817c.174.174.313.377.411.597H2V3.5A2.5 2.5 0 0 1 4.5 1h4.682Z" }),
        React.createElement("path", { d: "M2 12v.5A2.5 2.5 0 0 0 4.5 15h7a2.5 2.5 0 0 0 2.5-2.5V12H2Z" }),
        React.createElement("path", { d: "M2.792 6H3.8v5H2.792V9H1.008v2H0V6h1.008v2h1.784V6Z" }),
        React.createElement("path", { d: "M7.581 6H4v.979h1.189V11h1.05V6.979H7.58V6Z" }),
        React.createElement("path", { d: "M11.428 6H13v5h-.991V8.45c0-.516.006-1.023.019-1.52a57.896 57.896 0 0 1-.385 1.52L10.954 11h-.883l-.897-3.26-.214-.803c.012.497.019 1 .019 1.507V11H8V6h1.597l.537 1.958c.16.587.288 1.1.385 1.542.097-.441.223-.955.379-1.542L11.428 6Z" }),
        React.createElement("path", { d: "M14.775 6h-.972v5h2.904v-.979h-1.932V6Z" })));
});
